var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.homeConfig.carousel.length > 0)?_c('banner',{attrs:{"carousel":_vm.homeConfig.carousel}}):_vm._e(),(_vm.productCategory.length)?_c('product',{attrs:{"instrumentCategory":_vm.homeConfig.instrumentCategory,"productCategory":_vm.productCategory}}):_vm._e(),_c('about'),_c('solution')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }